module.exports = {
  "country": "SE",
  "artist": "Loreen ",
  "song": "Euphoria",
  "year": "2012",
  "place": "1",
  "spotify": "1xN7BpTAWnZkuSLOtRP6Qc"
};